import { render, staticRenderFns } from "./producto.vue?vue&type=template&id=34cc7d00&"
import script from "./producto.vue?vue&type=script&lang=js&"
export * from "./producto.vue?vue&type=script&lang=js&"
import style0 from "vue-swatches/dist/vue-swatches.min.css?vue&type=style&index=0&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports